import MainLayout from '@/views/MainLayout.vue'

const routes = [
  // {
  //   path: '/',
  //   redirect: '/visitor',
  // },
  {
    path: '/',
    name: 'MaiLayout',
    component: MainLayout,
    redirect: '/visitor',
    children: [
      {
        path: '/visitor',
        name: 'Visitor',
        component: () => import('../views/TabBar/Visitor.vue'),
        meta: { title: '预约' },
      },
      {
        path: '/Attendance',
        name: 'Attendance',
        component: () => import('../views/TabBar/Attendance.vue'),
        meta: { title: '考勤' },
      },
      {
        path: '/mine',
        name: 'Mine',
        component: () => import('../views/TabBar/Mine.vue'),
        meta: { title: '个人中心' },
      },
      // {
      //   path: '/leaveList',
      //   name: 'leaveList',
      //   component: () => import('../views/leaveList.vue'),
      //   meta: { title: '请假列表' },
      // },
    ],
  },





  // 公众号审批
  {
    path: '/approval',
    name: 'approval',
    component: () => import('../views/TabBar/Approval.vue'),
    meta: { title: '审批' },
  },

  // 企业微信审批
  {
    path: '/approvalQy',
    name: 'approvalQy',
    component: () => import('../views/TabBar/ApprovalQy.vue'),
    meta: { title: '审批' },
  },


  {
    path: '/qcode',
    name: 'qcode',
    component: () => import('../views/visitor/qcode.vue'),
    meta: { title: '访客预约码' },
  },

  {
    path: '/classesAttendance',
    name: 'classesAttendance',
    component: () => import('../views/Attendance/classesAttendance2.vue'),
    meta: { title: '学生出勤' },
  },
  {
    path: '/teacherAttendance',
    name: 'teacherAttendance',
    component: () => import('../views/Attendance/teacherAttendance.vue'),
    meta: { title: '老师月度出勤详单' },
  },
  {
    path: '/studentAttendance',
    name: 'studentAttendance',
    component: () => import('../views/Attendance/studentAttendance.vue'),
    meta: { title: '学生月度出勤详单' },
  },
  {
    path: '/notice-setting',
    name: '/notice-setting',
    component: () => import('../views/TabBar/NoticeSetting.vue'),
    meta: { title: '通知设置' },
  },
  // {
  //   path: '/leaveAudit',
  //   name: 'leaveAudit',
  //   component: () => import('../views/leaveAudit.vue'),
  //   meta: { title: '请假审批' },
  // },

  {
    path: '/role',
    name: 'role',
    component: () => import('../views/Mine/role.vue'),
    meta: { title: '角色切换' },
  },
  {
    path: '/leaveList',
    name: 'leaveList',
    component: () => import('../views/LeaveCommand/leaveList.vue'),
    meta: { title: '请假列表' },
  },
  {
    path: '/studentLeaveList',
    name: 'studentLeaveList',
    component: () => import('../views/LeaveCommand/studentLeaveList.vue'),
    meta: { title: '请假列表' },
  },
  {
    path: '/myattendance',
    name: 'myattendance',
    component: () => import('../views/Attendance/myattendance.vue'),
    meta: { title: '我的考勤' },
  },
  {
    path: '/attendanceStatistics',
    name: 'attendanceStatistics',
    component: () => import('../views/Attendance/attendanceStatistics.vue'),
    meta: { title: '考勤统计' },
  },

  {
    path: '/schoolBus',
    name: 'schoolBus',
    component: () => import('../views/Attendance/schoolBus.vue'),
    meta: { title: '校车运行展示' },
  },
  {
    path: '/outwork',
    name: 'outwork',
    component: () => import('../views/Attendance/outwork.vue'),
    meta: { title: '外勤' },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Login/Register.vue'),
    meta: { title: '绑定手机号' },
  },
  {
    path: '/noticeDetail',
    name: 'notice-detail',
    component: () => import('../views/WeChatConnection/NoticeDetail.vue'),
    meta: { title: '通知详情' },
  },



  // 公众号拜访预约
  {
    path: '/subscribe',
    name: 'subscribe',
    component: () => import('../views/MakeAppointment/Subscribe.vue'),
    meta: {
      title: '拜访预约',
    },
  },

  // 企业拜访预约
  {
    path: '/subscribeQy',
    name: 'subscribeQy',
    component: () => import('../views/MakeAppointment/SubscribeQy.vue'),
    meta: {
      title: '拜访预约',
    },
  },



  {
    path: '/visitorRecord',
    name: 'visitorRecord',
    component: () => import('../views/visitor/visitorRecord.vue'),
    meta: {
      title: '访客记录',
    },
  },
  {
    path: '/visitorDetail',
    name: 'visitorDetail',
    component: () => import('../views/visitor/visitorDetail.vue'),
    meta: {
      title: '访客详情',
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/Mine/Profile.vue'),
    meta: { title: '个人信息' },
  },
  {
    path: '/profile2',
    name: 'profile2',
    component: () => import('../views/Mine/profile2.vue'),
    meta: { title: '个人信息' },
  },
  {
    path: "/profile3",
    name: "profile3",
    component: () => import("../views/Mine/profile3.vue"),
    meta: { title: "个人信息3" },
  },
  {
    path: "/profileQy",
    name: "profileQy",
    component: () => import("../views/Mine/profileQy.vue"),
    meta: { title: "个人信息" },
  },


  // 公众号
  {
    path: '/detailSub',
    name: 'detailSub',
    component: () => import('../views/MakeAppointment/detail.vue'),
    meta: { title: '详情' },
  },

  // 企业微信公众号
  {
    path: '/detailSubQy',
    name: 'detailSubQy',
    component: () => import('../views/MakeAppointment/detailQy.vue'),
    meta: { title: '详情' },
  },




  {
    path: '/updateSub',
    name: 'updateSub',
    component: () => import('../views/MakeAppointment/updateSub.vue'),
    meta: { title: '修改' },
  },
  {
    path: '/avatar',
    name: 'avatar',
    component: () => import('../views/Mine/Avatar.vue'),
    meta: { title: '识别照片' },
  },
  {
    path: '/myApproval',
    name: 'myApproval',
    component: () => import('../views/Mine/myApproval.vue'),
    meta: { title: '我的审批' },
  },




  // 公众号我的预约
  {
    path: '/visited-history',
    name: 'visited-history',
    component: () => import('../views/Mine/VisitedHistory.vue'),
    meta: { title: '我的预约' },
  },

  // 企业微信我的预约
  {
    path: '/visited-historyQy',
    name: 'visited-historyQy',
    component: () => import('../views/Mine/VisitedHistoryQy.vue'),
    meta: { title: '我的预约' },
  },














  // 公众号预约通知
  {
    path: '/visNoticeDetail',
    name: 'visNoticeDetail',
    component: () => import('../views/WeChatConnection/visNoticeDetail.vue'),
    meta: { title: '预约通知' },
  },



  // 企业微信预约通知
  {
    path: '/visNoticeDetailQy',
    name: 'visNoticeDetailQy',
    component: () => import('../views/WeChatConnection/visNoticeDetailQy.vue'),
    meta: { title: '预约通知' },
  },








  // 公众号审批通知
  {
    path: '/approvalNoticeDetail',
    name: 'approvalNoticeDetail',
    component: () =>
      import('../views/WeChatConnection/approvalNoticeDetail.vue'),
    meta: { title: '审批通知' },
  },

  // 企业微信
  {
    path: '/approvalNoticeDetailQy',
    name: 'approvalNoticeDetailQy',
    component: () =>
      import('../views/WeChatConnection/approvalNoticeDetailQy.vue'),
    meta: { title: '审批通知' },
  },




  {
    path: '/transientSave',
    name: 'transientSave',
    component: () => import('../views/temporaryStorage/transientSave.vue'),
    meta: { title: '暂存' },
  },
  {
    path: '/inviteAddPeer',
    name: 'inviteAddPeer',
    component: () => import('../views/temporaryStorage/inviteAddPeer.vue'),
    meta: { title: '添加人员' },
  },
  {
    path: '/transientSaveSub',
    name: 'transientSaveSub',
    component: () => import('../views/temporaryStorage/transientSaveSub.vue'),
    meta: { title: '暂存详情' },
  },
  {
    path: '/schoolList',
    name: 'schoolList',
    component: () => import('../views/Mine/schoolList.vue'),
    meta: { title: '身份切换' },
  },
  {
    path: '/leaveForm',
    name: 'leaveForm',
    component: () => import('../views/LeaveCommand/leaveForm.vue'),
    meta: { title: '发起请假' },
  },
  {
    path: '/teacherLeaveForm',
    name: 'teacherLeaveForm',
    component: () => import('../views/LeaveCommand/teacherLeaveForm.vue'),
    meta: { title: '发起请假' },
  },
  {
    path: '/leaveDetail',
    name: 'leaveDetail',
    component: () => import('../views/LeaveCommand/leaveDetail.vue'),
    meta: { title: '请假详情' },
  },
  {
    path: '/pickupDetail',
    name: 'pickupDetail',
    component: () => import('../views/PickUpStation/pickupDetail.vue'),
    meta: { title: '代接送详情' },
  },
  {
    path: '/pickupForm',
    name: 'pickupForm',
    component: () => import('../views/PickUpStation/pickupForm.vue'),
    meta: { title: '申请代接送' },
  },
  {
    path: '/pickupList',
    name: 'pickupList',
    component: () => import('../views/PickUpStation/pickupList.vue'),
    meta: { title: '代接送列表' },
  },
  {
    path: '/accessForm',
    name: 'accessForm',
    component: () => import('../views/Access/accessForm.vue'),
    meta: { title: '进出时段申请' },
  },
  {
    path: '/accessList',
    name: 'accessList',
    component: () => import('../views/Access/accessList.vue'),
    meta: { title: '进出申请列表' },
  },
  {
    path: '/accessDetail',
    name: 'accessDetail',
    component: () => import('../views/Access/accessDetail.vue'),
    meta: { title: '进出申请详情' },
  },
  {
    path: '/401',
    name: '401',
    component: () => import('../views/NotFound/401.vue'),
    meta: { title: '无权限' },
  },
  {
    path: '/openVip',
    name: 'openvip',
    component: () => import('../views/Vip/OpenVip.vue'),
    meta: { title: '短视频订阅' },
  },
  {
    path: '/serviceAgreement',
    name: 'serviceAgreement',
    component: () => import('../views/Vip/serviceAgreement.vue'),
    meta: { title: '短视频订阅服务协议' },
  },
  {
    path: '/confirmOrder',
    name: 'confirmOrder',
    component: () => import('../views/Vip/ConfirmOrder.vue'),
    meta: { title: '订单确认' },
  },
  {
    path: '/paySuccess',
    name: 'paySuccess',
    component: () => import('../views/Vip/paySuccess.vue'),
    meta: { title: '支付成功' },
  },
  {
    path: '/orderList',
    name: 'orderList',
    component: () => import('../views/Vip/orderList.vue'),
    meta: { title: '订单列表' },
  },
  {
    path: '/bindService',
    name: 'bindService',
    component: () => import('../views/Vip/bindService.vue'),
    meta: { title: '修改订阅人员' },
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: () => import('../views/Vip/orderDetail.vue'),
    meta: { title: '订单详情' },
  },
  // {
  //   path: '/uploadDemo',
  //   name: 'uploadDemo',
  //   component: () => import('../views/uploadDemo.vue'),
  //   meta: { title: '图片上传实例' },
  // },
  {
    path: '/wxUpload',
    name: 'wxUpload',
    component: () => import('../views/demo/wxUpload.vue'),
    meta: { title: 'wxUpload上传' },
  },
  {
    path: '/bindPhone',
    name: 'bindPhone',
    component: () => import('../views/Mine/bindPhone.vue'),
    meta: { title: '绑定手机号' },
  },
  {
    path: '/fullscreen',
    name: 'fullscreen',
    component: () => import('../views/fullScreen.vue'),
    meta: { title: '' },
  },
  {
    path: '/singleClasses',
    name: 'singleClasses',
    component: () => import('../views/Attendance/singleClassesAttendance.vue'),
    meta: { title: '学生每日出勤详单' },
  },
  {
    path: '/schoolTeacher',
    name: 'schoolTeacher',
    component: () => import('../views/Attendance/schoolTeacher.vue'),
    meta: { title: '老师出勤' },
  },
  {
    path: '/schoolTeacherClass',
    name: 'schoolTeacherClass',
    component: () => import('../views/Attendance/schoolTeacherClass.vue'),
    meta: { title: '老师每日出勤详单' },
  },
  // {
  //   path: '/teacherAttendanceSummary',
  //   name: 'teacherAttendanceSummary',
  //   component: () => import('../views/Attendance/teacherAttendanceSummary.vue'),
  //   meta: { title: '老师月度出勤汇总详单' },
  // },
  {
    path: '/studentAttendanceList',
    name: 'studentAttendanceList',
    component: () => import('../views/Attendance/studentAttendanceList.vue'),
    meta: { title: '学生全勤榜' },
  },

  {
    path: '/studentAbsenceList',
    name: 'studentAbsenceList',
    component: () => import('../views/Attendance/studentAbsenceList.vue'),
    meta: { title: '学生缺勤榜' },
  },

  {
    path: '/studentMonthAttendance',
    name: 'studentMonthAttendance',
    component: () => import('../views/Attendance/studentMonthAttendance.vue'),
    meta: { title: '学生出勤月汇总' },
  },

  {
    path: '/studentMonthCalendar',
    name: 'studentMonthCalendar',
    component: () => import('../views/Attendance/studentMonthCalendar.vue'),
    meta: { title: '学生月度出勤详单' },
  },


  // 成绩查询
  {
    path: '/achievement',
    name: 'achievement',
    component: () => import('../views/Mine/achievement.vue'),
    meta: { title: '成绩查询' },
  },


  // 成绩查询接口
  {
    path: '/achievementDetail',
    name: 'achievementDetail',
    component: () => import('../views/Mine/achievementDetail.vue'),
    meta: { title: '成绩查询' },
  },


  // 活动室预约相关页面
  {
    path: '/roomAppointment',
    name: 'roomAppointment',
    component: () => import('../views/ActivityRoom/appointment'),
    meta: { title: '活动室预约' }
  },

  // 活动室预约相关页面
  {
    path: '/roomReservation',
    name: 'roomReservation',
    component: () => import('../views/ActivityRoom/reservation'),
    meta: {
      title: '活动室预约'
    }
  },
  {
    path: '/abnormalbedtime',
    name: 'returnbedTime',
    component: () => import('../views/WeChatConnection/AbnormalBedtime.vue'),
    meta: { title: '宿舍归寝异常学生清单' }
  },

  {
    path: "/alarmMessage",
    name: "alarmMessage",
    component: () => import("../views/WeChatConnection/AlarmMessage.vue"),
    meta: { title: "报警消息明细" },
  },

  {
    path: '/goBack',
    name: 'goBack',
    component: () => import('../views/WeChatConnection/goBack/index.vue'),
    meta: { title: '归寝查询' }
  },
  // 风险加剧详情
  {
    path: '/userRiskIntensifyUrl',
    name: 'riskIncreasedDetails',
    component: () => import('../views/WeChatConnection/RiskDetail.vue'),
    meta: { title: '人员风险加剧明细' }
  },
  {
    path: "/abnormalTrackUrl",
    name: "abnormalTrackUrl",
    component: () => import("../views/WeChatConnection/abnormalTrackUrl.vue"),
    meta: { title: "人员轨迹异常信息明细" },
  },

  {
    path: "/unReturnRecordLinkUrl",
    name: "unReturnRecordLinkUrl",
    component: () => import("../views/WeChatConnection/unReturnRecordLinkUrl.vue"),
    meta: { title: "宿舍异常信息明细" },
  },
  // 活动室审批列表
  {
    path: '/roomApproval',
    name: 'roomApproval',
    component: () => import('../views/ActivityRoom/roomapproval'),
    meta: {
      title: '审批'
    }
  },


  // 活动室审核详情 （老师审核）
  {
    path: '/roomApprovalDetail',
    name: 'roomApprovalDetail',
    component: () => import('../views/ActivityRoom/roomapprovaldetail'),
    meta: {
      title: '预约详情'
    }
  },

  // 获取室预约详情 （学生） 
  {
    path: '/roomReservationDetail',
    name: 'roomReservationDetail',
    component: () => import('../views/ActivityRoom/roomReservationDetail'),
    meta: {
      title: '预约详情'
    }
  },

  // 预约记录
  {
    path: '/roomAppointRecord',
    name: 'roomAppointRecord',
    component: () => import('../views/ActivityRoom/roomAppointRecord'),
    meta: {
      title: '预约记录'
    }
  },

  // cas登录承接ticket
  {
    path: '/casLogin',
    name: 'casLogin',
    component: () => import('../views/ActivityRoom/casLogin'),
    meta: {
      title: '登录'
    },
  },

    // 高校公众号首页
  {

    path: '/home',
    name: 'home',
    component: () => import('../views/Mine/Home.vue'),
    meta: { title: '幼高专校园安全大脑平台' }

  }
]

export default routes
